module.exports = __webpack_public_path__ + "static/media/400076_02.ddd14d9b.png";